import { DataSource, HorizontalSpacer, Label, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutAdditionalDetailsLTLUnauthenticated extends Layout {
    horizontalspacer1: HorizontalSpacer;
    labelAdditionalDetails: Label;
    labelConsigneeContact: Label;
    labelConsigneeContactName: Label;
    labelConsigneePhone: Label;
    labelReferenceNumbers: Label;
    labelShipperContact: Label;
    labelShipperContactName: Label;
    labelShipperPhone: Label;
    panelAdditionalDetails: Panel;
    panelBilling: Panel;
    panelCarrier: Panel;
    panelConsigneeContact: Panel;
    panelLastKnownLocation: Panel;
    panelShipperContact: Panel;
    sourceCustomerOrderDetail: DataSource;
    tableReferenceNumbers: Table;
    textboxBillingMethod: Textbox;
    textboxCustomername: Textbox;
    textboxLastKnownLocation: Textbox;
    textboxPayeename: Textbox;
}
